import { render, staticRenderFns } from "./WorkspaceExpandGraphPanel.vue?vue&type=template&id=5ee82e02&scoped=true"
import script from "./WorkspaceExpandGraphPanel.vue?vue&type=script&lang=js"
export * from "./WorkspaceExpandGraphPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceExpandGraphPanel.vue?vue&type=style&index=0&id=5ee82e02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee82e02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ee82e02')) {
      api.createRecord('5ee82e02', component.options)
    } else {
      api.reload('5ee82e02', component.options)
    }
    module.hot.accept("./WorkspaceExpandGraphPanel.vue?vue&type=template&id=5ee82e02&scoped=true", function () {
      api.rerender('5ee82e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceExpandGraphPanel.vue"
export default component.exports